import { PagedRequestDto } from './paged-request.model';
import { UserRole } from './auth.model';

export interface User {
  createdAt: string;
  updatedAt: string;
  id: string;
  email: string;
  role: UserRole;
  firstName: string;
  lastName: string;
  fullName: string;
  phone: string;
  isActive: boolean;
  emailVerified: boolean;
  lastLogin: string;
  mustChangePassword: boolean;
  ssn?: string;
}

export interface CreateUser extends Partial<User> {
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
}

export interface UserChangePassword {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface UpdateUserDto {
  firstName: string;
  lastName: string;
  phone?: string | null;
  isActive?: boolean;
  role?: UserRole;
}

export interface UserPayload extends PagedRequestDto {
  corporateId?: number | null;
  facilityId?: number | null;
  role?: UserRole | null;
  isActive?: boolean | null;
  email?: string | null;
}
